import { Box, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { getUsageTypeByValue } from "../../constants/enums";


const usagesColumns = ( handleView, colors) => [
  {
    field: "application_name",
    headerName: "Aplicación",
    headerAlign: "left",
    align: "left",
    flex: 1,
    renderCell: (params) => {
      return params.value ? params.value : 'N/A'
    }
  },
  {
    field: "usage_count",
    headerName: "Productos",
    type: "number",
    headerAlign: "left",
    align: "left",
    flex: 0.5,
  },
  {
    field: "detail",
    headerName: "Detalle",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      return params.value ? params.value : 'N/A'
    }
  },
  {
    field: "type",
    headerName: "Tipo",
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params) => {
      const typeInfo = getUsageTypeByValue(params.value);

      return (
      <Box
        sx={{
          color: typeInfo.color,
          fontWeight: "bold",
          backgroundColor: `${typeInfo.color}30`, // Transparent background
          border: ` ${typeInfo.color}`, // Corner borders
          borderRadius: "8px", // Rounded corners
          padding: "8px",
          display: "inline-flex",
          justifyContent: "center",
          alignItems: "center",
          width: "30%",
          height: "50%",
          textShadow: `0 0 30px ${typeInfo.color}`, // Shiny text effect
          overflow: "hidden", // Prevent shadow from going outside the box
        }}
      >
        {typeInfo.label}
      </Box>
      );
    },
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    flex: 0.5,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" justifyContent="center" gap="10px">
        <IconButton onClick={() => handleView(params.row.id)} sx={{ color: colors.grey[100] }}>
          <VisibilityOutlinedIcon />
        </IconButton>
      </Box>
    ),
  },
];

export { usagesColumns }